var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React from 'react';
import ReactDOM from 'react-dom';
import UserSelectionModal from '../UserSelectionModal';
import AboutModal from '../AboutModal';
import FeedbackModal from '../FeedbackModal';
import JoinMeetingModal from '../JoinMeetingModal';
import CommonModal from '../CommonModal';
import { UserCardModal } from '../WebUserCardModal';
import AppTrailApplyModal from '../AppTrailApplyModal';
var destroyFns = [];
var Modals = function () {
    return null;
};
var openModal = function (_a) {
    var propsConfig = _a.propsConfig, modalClass = _a.modalClass;
    var div = document.createElement('div');
    document.body.appendChild(div);
    var currentConfig = __assign(__assign({}, propsConfig), { onClose: onClose, visible: true });
    function destroy() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var unmountResult = ReactDOM.unmountComponentAtNode(div);
        if (unmountResult && div.parentNode) {
            div.parentNode.removeChild(div);
        }
        for (var i = 0; i < destroyFns.length; i++) {
            var fn = destroyFns[i];
            // eslint-disable-next-line no-use-before-define
            if (fn === onClose) {
                destroyFns.splice(i, 1);
                break;
            }
        }
    }
    function render(_a) {
        var props = __rest(_a, []);
        setTimeout(function () {
            var factory = React.createFactory(modalClass);
            ReactDOM.render(factory(__assign({}, props)), div);
        });
    }
    function onClose() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        currentConfig = __assign(__assign({}, currentConfig), { visible: false, 
            // @ts-ignore
            afterClose: destroy.bind.apply(destroy, __spreadArrays([this], args)) });
        render(currentConfig);
    }
    function update(newConfig) {
        currentConfig = __assign(__assign({}, currentConfig), newConfig);
        render(currentConfig);
    }
    render(currentConfig);
    destroyFns.push(close);
    return {
        destroy: onClose,
        update: update,
    };
};
Modals.JoinMeeting = function (props) {
    return openModal({
        propsConfig: props,
        modalClass: JoinMeetingModal,
    });
};
Modals.About = function (props) {
    return openModal({
        propsConfig: props,
        modalClass: AboutModal,
    });
};
// 通用modal
Modals.CommonModal = function (props) {
    return openModal({
        propsConfig: props,
        modalClass: CommonModal,
    });
};
Modals.Feedback = function (_a) {
    var onSubmit = _a.onSubmit, onCancel = _a.onCancel, userData = _a.userData, t = _a.t, uploadImageControler = _a.uploadImageControler, logFiles = _a.logFiles, isHiddenSelectLog = _a.isHiddenSelectLog, ossBaseUrl = _a.ossBaseUrl, headNetCheckBtn = _a.headNetCheckBtn, headNetCheckCallback = _a.headNetCheckCallback;
    return openModal({
        propsConfig: {
            onSubmit: onSubmit,
            onCancel: onCancel,
            userData: userData,
            t: t,
            uploadImageControler: uploadImageControler,
            logFiles: logFiles,
            isHiddenSelectLog: isHiddenSelectLog,
            ossBaseUrl: ossBaseUrl,
            headNetCheckBtn: headNetCheckBtn,
            headNetCheckCallback: headNetCheckCallback,
        },
        modalClass: FeedbackModal,
    });
};
Modals.UserSelecton = function (config, onOk, fns, onCancel
// eslint-disable-next-line max-params
) {
    var div = document.createElement('div');
    document.body.appendChild(div);
    var currentConfig = __assign({ options: config, onClose: onClose, visible: true }, fns);
    function destroy() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var unmountResult = ReactDOM.unmountComponentAtNode(div);
        if (unmountResult && div.parentNode) {
            div.parentNode.removeChild(div);
        }
        for (var i = 0; i < destroyFns.length; i++) {
            var fn = destroyFns[i];
            // eslint-disable-next-line no-use-before-define
            if (fn === onClose) {
                destroyFns.splice(i, 1);
                break;
            }
        }
    }
    function render(_a) {
        var props = __rest(_a, []);
        setTimeout(function () {
            ReactDOM.render(React.createElement(UserSelectionModal, __assign({}, props, { onOk: onOk, onCancel: onCancel })), div);
        });
    }
    function onClose() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        currentConfig = __assign(__assign({}, currentConfig), { visible: false, 
            // @ts-ignore
            afterClose: destroy.bind.apply(destroy, __spreadArrays([this], args)) });
        render(currentConfig);
    }
    function update(newConfig) {
        currentConfig = __assign(__assign({}, currentConfig), newConfig);
        render(currentConfig);
    }
    render(currentConfig);
    destroyFns.push(close);
    return {
        destroy: onClose,
        update: update,
    };
};
Modals.UserCard = function (config, 
// onOk: (data: UserSelectionResult) => Promise<void>,
fns) {
    var div = document.createElement('div');
    document.body.appendChild(div);
    var currentConfig = __assign({ options: config, onClose: onClose, visible: true }, fns);
    function destroy() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var unmountResult = ReactDOM.unmountComponentAtNode(div);
        if (unmountResult && div.parentNode) {
            div.parentNode.removeChild(div);
        }
        for (var i = 0; i < destroyFns.length; i++) {
            var fn = destroyFns[i];
            // eslint-disable-next-line no-use-before-define
            if (fn === onClose) {
                destroyFns.splice(i, 1);
                break;
            }
        }
    }
    function render(_a) {
        var props = __rest(_a, []);
        setTimeout(function () {
            ReactDOM.render(React.createElement(UserCardModal, __assign({}, props)), div);
        });
    }
    function onClose() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        currentConfig = __assign(__assign({}, currentConfig), { visible: false, 
            // @ts-ignore
            afterClose: destroy.bind.apply(destroy, __spreadArrays([this], args)) });
        render(currentConfig);
    }
    function update(newConfig) {
        currentConfig = __assign(__assign({}, currentConfig), newConfig);
        render(currentConfig);
    }
    render(currentConfig);
    destroyFns.push(close);
    return {
        destroy: onClose,
        update: update,
    };
};
Modals.AppTrailApply = function (props) {
    var div = document.createElement('div');
    document.body.appendChild(div);
    function destroy() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var unmountResult = ReactDOM.unmountComponentAtNode(div);
        if (unmountResult && div.parentNode) {
            div.parentNode.removeChild(div);
        }
    }
    function render() {
        setTimeout(function () {
            ReactDOM.render(React.createElement(AppTrailApplyModal, __assign({}, props)), div);
        });
    }
    render();
};
export default Modals;
//# sourceMappingURL=index.js.map